export default __webpack_public_path__ + "static/media/hair-0-5.0fb46478.svg";